<template>
<div class="thal-page">
  <nav2 :title="$t('thalIndex.t_3')"></nav2>
  <div class="record-list">
    <div v-for="(item,index) in list_2d" class="record-margin">
      <div class="record-name" v-if="item.lottery_record.length>0">
        <span>{{ item.lottery_name }}-{{ item.lottery_record[0].lottery_date }}</span>
        <span class="record-name-line"></span>
      </div>
      <div class="record-item"  v-for="(twoitem,index) in item.lottery_record">
        <div class="record-time">
          <div class="record-time-left">
            <span>{{ twoitem.stop_buy_time.replace(" ", ":").replace(/\\:/g, "-").split(":")[1]+':'+twoitem.stop_buy_time.replace(" ", ":").replace(/\\:/g, "-").split(":")[2] }} {{$t('thalIndex.t_9')}}</span>
            <span>{{$t('thalIndex.t_10')}}</span>
          </div>
          <div class="record-num">{{ twoitem.open_code }}</div>
          <div class="record-close">
            <span>{{$t('thalIndex.t_11')}}</span>
            <span>{{twoitem.stop_buy_time.replace(" ", ":").replace(/\\:/g, "-").split(":")[1]+':'+twoitem.stop_buy_time.replace(" ", ":").replace(/\\:/g, "-").split(":")[2]}} </span>
          </div>
        </div>
        <div class="record-int">
          <div class="record-int-line">{{ twoitem.stop_buy_time.replace(" ", ":").replace(/\\:/g, "-").split(":")[1]+':'+twoitem.stop_buy_time.replace(" ", ":").replace(/\\:/g, "-").split(":")[2] }} {{$t('thalIndex.t_15')}}</div>
          <div class="record-int-submit" @click.stop="_bet_note(item.is_hf,item.id,twoitem.record_id,item.lottery_name,item.is_tally)">{{$t('thalIndex.t_14')}}</div>
        </div>
      </div>


      <!--    <div class="record-item">
      <div class="record-time">
        <div class="record-time-left">
          <span>9:30 {{$t('thalIndex.t_9')}}</span>
          <span>{{$t('thalIndex.t_10')}}</span>
        </div>
        <div class="record-num">95</div>
        <div class="record-close">
          <span>{{$t('thalIndex.t_11')}}</span>
          <span>9:30 {{$t('thalIndex.t_12')}}</span>
        </div>
      </div>
      <div class="record-int">
        <div class="record-int-line"><span>{{$t('thalIndex.t_16')}} 1,436.46</span><span>{{$t('thalIndex.t_17')}} 20,123.35</span></div>
        <div class="record-int-submit">{{$t('thalIndex.t_14')}}</div>
      </div>
    </div>-->
      <!--    <div class="record-item">
            <div class="record-time">
              <div class="record-time-left">
                <span>9:30 {{$t('thalIndex.t_9')}}</span>
                <span>{{$t('thalIndex.t_10')}}</span>
              </div>
              <div class="record-num">95</div>
              <div class="record-close">
                <span>{{$t('thalIndex.t_11')}}</span>
                <span>9:30 {{$t('thalIndex.t_12')}}</span>
              </div>
            </div>
            <div class="record-int">
              <div class="record-int-line">{{$t('thalIndex.t_15')}}</div>
              <div class="record-int-submit">{{$t('thalIndex.t_14')}}</div>
            </div>
          </div>-->
      <!--    <div class="record-item">
            <div class="record-time">
              <div class="record-time-left">
                <span>9:30 {{$t('thalIndex.t_9')}}</span>
                <span class="record-red">{{$t('thalIndex.t_18')}}</span>
              </div>
              <div class="record-num">95</div>
              <div class="record-close">
                <span>{{$t('thalIndex.t_11')}}</span>
                <span>9:30 {{$t('thalIndex.t_12')}}</span>
              </div>
            </div>
            <div class="record-int">
              <div class="record-int-line"><span>{{$t('thalIndex.t_16')}} 1,436.46</span><span>{{$t('thalIndex.t_17')}} 20,123.35</span></div>
              <div class="record-int-submit">{{$t('thalIndex.t_14')}}</div>
            </div>
          </div>-->
<!--      <div class="record-modern">
        <div class="record-modern-num">
          <div>9:30 {{$t('thalIndex.t_12')}}</div>
          <div><span>{{$t('thalIndex.t_19')}}<em>76</em></span><span>{{$t('thalIndex.t_20')}}<em>95</em></span></div>
        </div>
        <div class="record-modern-num">
          <div>02:00 {{$t('thalIndex.t_12')}}</div>
          <div><span>{{$t('thalIndex.t_19')}}<em>76</em></span><span>{{$t('thalIndex.t_20')}}<em>95</em></span></div>
        </div>
      </div>-->



    </div>




    <div v-for="(item,index) in list_3d" :key="index" class="record-margin">
      <div v-for="(twoitem,index) in item.lottery_record">
        <div class="record-name"  v-if="item.lottery_record.length>0">
          <span>{{ item.lottery_name }}-{{ item.lottery_record[0].lottery_date}}</span>
          <span class="record-name-line2"></span>
          <div class="record-int-submit" @click.stop="_bet_note(item.is_hf,item.id,twoitem.record_id,item.lottery_name,item.is_tally)">{{$t('thalIndex.t_14')}}</div>
        </div>
        <div class="record-3d-num" >
          <span>{{ twoitem.open_code }}</span>
          <span>{{$t('thalIndex.t_10')}}</span>
        </div>
      </div>
    </div>


  </div>


  <sesstion ref="sesstion" title="record"></sesstion>

</div>
</template>

<script>
  import nav2 from '../THAL/navs'
  import sesstion from "./sesstion.vue";
    export default {
    components:{sesstion, nav2},
        name: "record",
      data(){
        return{
          list:[],
          list_2d:[],
          list_3d:[],
          platform_id:'',
        }
      },
      created() {
        let _self=this;
        let platform_id=_self.$route.query.platform_id;
        if(platform_id!='' && platform_id!=undefined){
          _self.platform_id=platform_id;
          _self._today();
        }

      },
      methods:{
        _bet_note:function(is_hf,id,record_id,lottery_name,is_tally) {
          let _self=this;
          _self.$refs.sesstion.record_id=record_id;
          _self.$refs.sesstion.lottery_id=id;
          _self.$refs.sesstion.is_hf=is_hf;
          _self.$refs.sesstion.lottery_name=lottery_name;
          _self.$refs.sesstion.is_tally=is_tally
          this.$refs.sesstion._record();
        },
        _today:function (){
          let _self=this;
          _self.list_2d=[];
          _self.list_3d=[];
          this._PublicFun.getData('2', 'get', 'lottery/today_record/'+_self.platform_id, {}, function (result) {
            if(result.data['status_code']==200){
              _self.list=result.data['data'];
              for(var i=0;i<_self.list.length;i++){
                if(_self.list[i].is_hf==1){
                  _self.list_2d.push(_self.list[i]);
                }else if(_self.list[i].is_hf==0){
                  _self.list_3d.push(_self.list[i])
                }
              }
            }
          })
        },
      }
    }

</script>

<style scoped>
  .record-list{
    display: block;
    margin: 65px auto 0;
    padding: 0;
    width: 100%;
    max-width: 750px;
  }
  .record-name{
    display: flex;
    align-items: center;
    width: 94%;
    margin: 0 auto;
    padding: 0;
    color:#B4B4B4;
    font-size: 12px;
    position: relative;

  }
  .record-margin{
    display: block;
    width: 100%;
    margin: 15px auto;
    padding: 0;
  }
  .record-name-line{
    position: absolute;
    left: 100px;
    right: 0;
    border: 1px solid #B4B4B4;
  }
  .record-name-line2{
    position: absolute;
    left: 100px;
    right: 85px;
    border: 1px solid #B4B4B4;
  }
  .record-item{
    display: block;
    width: 94%;
    margin: 15px auto 0;
    padding: 0;
  }
  .record-time{
    display: flex;
    width: 100%;
    position: relative;
    padding: 5px 0;

  }
  .record-time-left{
    width: 50%;
    display: block;
    margin: 5px 0 0;
    padding: 0;
    text-align: center;
  }
  .record-time-left span{
    display: block;
    width: 100%;
    text-align: center;
    margin: 0 auto;
    padding: 0;
  }
  .record-time-left span:first-child{
    color: #EED285;
    font-size: 15px;
    margin-bottom: 3px;
  }
  .record-time-left span:nth-child(2){
    color: #28B42D;
    zoom: 0.7;
  }
  .record-red{
    color: red !important;
  }
  .record-num{
    display: block;
    width: 50%;
    margin: 0;
    text-indent: 2rem;
    font-size: 30px;
    font-weight: bold;
    color: #EED285;

  }
  .record-close{
    position: absolute;
    right: 0;
    top: 0;
    color: #B4B4B4;
    font-size: 10px;
  }
  .record-close span{
    display: block;
    text-align: center;
  }
  .record-close span:first-child{
    margin-bottom: 3px;
  }
  .record-int{
    display: block;
    width: 100%;
    margin: 5px auto;
    min-height: 30px;
    position: relative;

  }
  .record-int-line{
    border: 1px solid #EED285;
    border-radius: 5px;
    position: absolute;
    left: 0;
    right: 85px;
    top: 50%;
    height: 25px;
    display: flex;
    align-items: center;
    padding: 2px;
    font-size: 12px;
    color: #EED285;

    transform: translateY(-50%);
  }
  .record-int-line span{
    display: flex;
    align-items: center;
    width: 50%;
    margin: 0;
    padding: 0 ;
    height: 100%;
    line-height: 100%;
   justify-content: left;
    position: relative;
  }
  .record-int-line span em{

  }
  .record-int-line span:first-child:after{
    position: absolute;
    top: -2px;
    content: '';
    bottom: 0;
    right: 0;
    height: 29px;
    border-right: 1px solid #EED285;
  }
  .record-int-line span:nth-child(2){
    padding-left: 2px;
  }
  .record-int-submit{
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    background-color: #EDD185;
    font-size: 13px;
    border-radius: 5px;
    width: 80px;
    min-height: 25px;
    color: #333333;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    line-height: 25px;
  }
  .record-modern{
    display: flex;
    width: 94%;
    margin: 15px auto;
    padding: 0;
    align-items: center;

  }
  .record-modern-num{
    display: block;
    width: 50%;
    margin: 0;
    padding: 5px 0;
    text-align: center;
    border: 1px solid #EDD185;
    height: 60px;
    border-radius: 5px;
  }
  .record-modern-num:first-child{
    margin-right: 5px;
  }
  .record-modern-num:last-child{
    margin-left: 5px;
  }
  .record-modern-num div:first-child{
    color: #EDD185;
    text-align: center;
    padding: 5px 0;
    font-size: 10px;
    font-weight: bold;
  }
  .record-modern-num div:nth-child(2){
    display: flex;
    width: 100%;
    margin: 0 auto;
    padding: 0;
  }
  .record-modern-num div:nth-child(2) span{
    display: block;
    width: 50%;
    margin: 0;
    padding: 0;
    color: #B4B4B4;
    text-align: center;
    font-size: 13px;
  }
  .record-modern-num div:nth-child(2) span em{
    display: block;
    width: 100%;
    text-align: center;
    color: #EDD185;
    padding-top: 5px;
    font-weight: bold;
  }
  .record-3d-num{
    display: block;
    width: 94%;
    margin: 20px auto;
    padding: 0;
    text-align: center;
  }
  .record-3d-num span{
    display: block;
    width: 100%;
    text-align: center;
  }
  .record-3d-num span:first-child{
    font-weight: bolder;
    font-size: 30px;
    color: #EDD185;
  }
  .record-3d-num span:nth-child(2){
    color: #28B42D;
    margin-top: 10px;
    font-size: 12px;
    zoom: 0.8;
  }

</style>



// WEBPACK FOOTER //
// src/components/THAL/Record.vue